module.exports = __webpack_public_path__ + "static/media/spid-idp-intesaid~xcxRNxJf.a4ea157f.svg";